import { Component } from '@angular/core';
import { LessonCardHomePageComponent } from '../lesson-card-home-page/lesson-card-home-page.component';
import { DwComponent, DwComponentType, DwMetaDataListCardConfigData } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames } from '../../../../../meta-data/app-meta-data.service';

@DwComponent<DwMetaDataListCardConfigData>({
  name: 'Continuing Home Page Card (Redesign)',
  key: 'continuingHomePageCardRedesign',
  componentType: DwComponentType.card,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.CourseLesson,
  configData: {
    contentItemDefinitions: [{
      display: 'Main',
      contentItemKey: 'main'
    }]
  }
})
@Component({
  selector: 'app-continuing-home-page-card-redesign',
  templateUrl: './continuing-home-page-card-redesign.component.html',
  styleUrls: ['./continuing-home-page-card-redesign.component.scss']
})
export class ContinuingHomePageCardRedesignComponent extends LessonCardHomePageComponent {

  get topEyebrow(): string {
    const d = this.data as any;
    const parts = [
      d?.CourseName || d?.CourseIdDisplay,
      d?.ModuleName,
      d?.LessonName
    ].filter(Boolean).map((p: string) => p.toUpperCase());
    return parts.join(' · ');
  }

  get bottomEyebrow(): string {
    const d = this.data as any;
    const courseLabel = d?.CourseIdDisplay || d?.CourseName || 'YOUR COURSE';
    return `CONTINUE · ${String(courseLabel).toUpperCase()}`;
  }

  get progressWidthPercent(): number {
    const v = (this.data as any)?.CourseLessonProgressPercentComplete;
    if (typeof v !== 'number' || isNaN(v)) {
      return 0;
    }
    return Math.max(0, Math.min(100, v));
  }

  get timeRemainingLabel(): string | null {
    const d = this.data as any;
    const totalMin = d?.LessonDurationMinutes ?? d?.LessonLengthMinutes;
    const remainingMin = d?.LessonDurationRemainingMinutes ?? d?.LessonRemainingMinutes;
    if (typeof totalMin === 'number' && typeof remainingMin === 'number') {
      return `${remainingMin} min remaining of ${totalMin} min`;
    }
    return null;
  }
}
